import {bindable, customElement} from 'aurelia-framework';

@customElement('sio-form-error')
export class FormError
{
    @bindable
    field;
}
